import { StatsTimeContextBar } from "./StatsTimeContextBar.tsx";
import type { TrendRange } from "./StatsTrendControls.tsx";

type Props = {
  readonly timezone: string;
  readonly statsDay?: string | undefined;
  readonly range?: TrendRange | undefined;
  readonly windowStartAt?: string | null | undefined;
  readonly windowEndAt?: string | null | undefined;
};

/** @deprecated 使用 StatsTimeContextBar；保留别名兼容旧 import */
export function BotTimezoneNotice(props: Props) {
  return (
    <StatsTimeContextBar
      businessTimezone={props.timezone}
      businessDay={props.statsDay}
      range={props.range}
      windowStartAt={props.windowStartAt}
      windowEndAt={props.windowEndAt}
    />
  );
}
